<template>
    <section class="sidebarFilter">
        <p class="sidebarFilter__desc">
            {{ trans('FORM_SEARCH_REGION_FOCUS_DESCRIPTION') }}
        </p>
        <CustomSearchDropdown
            id="inlineDropdown__regionalBoost"
            data-gtm="sidebarFilter__regionalBoost"
            :default="filterOptions[0]"
            :value="filterOption"
            :disabled="disableRegionalBoost"
            :options="filterOptions"
            element="sidebarFilter__regionalBoost"
            :bordered="true"
            @changeValue="selectRegionalBoost" />
    </section>
</template>

<script>
    import { computed } from 'vue';
    import CustomSearchDropdown from './searchDropdown';
    import { useGetters } from 'composables/useVuex';
    import Translator from 'tools/trans';
    const IDRELEVANCE_VALUE = 'idrelevance';
    const PUBLICATIONDATE_VALUE = 'publicationDate';
    export default {
        name: 'RegionalBoostFilter',
        components: {
            CustomSearchDropdown,
        },
        props: {
            sortSelection: { type: String, default: IDRELEVANCE_VALUE },
        },
        data() {
            return {
                selectedRegionalBoost: '',
                disableRegionalBoost: false,
            };
        },
        watch: {
            sortSelection(value) {
                if (value === PUBLICATIONDATE_VALUE) {
                    this.disableRegionalBoost = true;

                    return;
                }
                this.disableRegionalBoost = false;
            },
        },
        methods: {
            trans: Translator.trans,
            selectRegionalBoost(region) {
                this.selectedRegionalBoost = region;
                this.$emit('selected-regionalBoost', this.selectedRegionalBoost);
                this.$parent.$emit('selected-regionalBoost', this.selectedRegionalBoost);
            },
        },
        mounted() {
            this.sort === PUBLICATIONDATE_VALUE ? this.disableRegionalBoost = true : false;
        },
        setup() {
            const filterOption = computed(() => {
                      return getters.focus.value || '-1';
                  }),
                  filterOptions = computed(() => {
                      return getters.countries.value.map(item => {
                          return {
                              value: item.value,
                              name: Translator.trans(item.label),
                          };
                      });
                  });
            const getters = {
                ...useGetters('search', [
                    'query',
                    'resultCount',
                    'resultArray',
                    'masterTags',
                    'promotedArray',
                    'repoArray',
                    'entity',
                    'entityName',
                    'getTitle',
                    'getContent',
                    'currentPage',
                    'totalFound',
                    'totalPages',
                    'loading',
                    'activeTab',
                    'topic',
                    'topics',
                    'countries',
                    'path',
                    'sort',
                    'focus',
                    'location',
                    'archive',
                    'tags',
                    'getShowSidebar',
                ]),
            };

            return {
                ...getters,
                filterOption,
                filterOptions,
            };
        },
    };
</script>
